import { useMutation, useQueryClient } from "@tanstack/react-query";
import { supabaseClient } from "../utils/supabase";
import { getStoredAdminPassword } from "../stores/adminAccessStore";

interface AssignStudyNumberParams {
    profileId: string;
    studyNumber: number;
}

interface AssignStudyNumberResponse {
    profile: {
        profile_id: string;
        phone: string;
        profile_index: number;
        study_number: number;
        created_at: string;
    };
}

export function useAssignStudyNumber() {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: async ({ profileId, studyNumber }: AssignStudyNumberParams) => {
            const adminPassword = getStoredAdminPassword();
            if (!adminPassword) {
                throw new Error("Admin password required");
            }

            const { data, error } = await supabaseClient.functions.invoke<AssignStudyNumberResponse>(
                "admin-assign-study-number",
                {
                    body: {
                        adminPassword,
                        profileId,
                        studyNumber,
                    },
                }
            );

            if (error) {
                throw error;
            }

            if (!data?.profile) {
                throw new Error("Failed to assign study number");
            }

            return data.profile;
        },
        onSuccess: async () => {
            await queryClient.invalidateQueries({ queryKey: ["admin-dashboard"] });
            await queryClient.invalidateQueries({ queryKey: ["study-tracker"] });
        },
    });
}
